import { useInfiniteQuery } from '@tanstack/react-query';
import { getHistory } from '../services/chatMessages';

export const useMessagesQuery = (trip_id: string) => {
    return useInfiniteQuery({
        queryKey: ['chatHistory:cursor', trip_id],
        queryFn: ({ pageParam = null }) => getHistory(parseInt(trip_id!, 10), pageParam),
        initialPageParam: null as string | null,
        getNextPageParam: (lastPage) => lastPage?.next ?? undefined,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: 1,
    });
};
